/* eslint-disable jsx-a11y/anchor-is-valid */

import * as React from "react";
import {Fragment} from "react";
import {SettingsService} from "../../services/SettingsService";
import {getContainer} from "../../ioc/IOCSetup";
import {LoadingViewState, RouterView} from "../RouterView";
import {FieldSetListener, Form, FormListener, SimpleFieldSet} from "../form/Form";
import {RouteComponentProps, withRouter} from "react-router";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {FormGroup} from "../form/FormGroup";
import {FormInput, FormMap} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {Menu, MenuItem, MenuItemType, Settings} from "../../http/protocol";
import "./SettingsGeneralView.scss";
import {Modal} from "react-bootstrap";
import {SelectInput} from "../form/SelectInput";
import {Case, Switch} from "../form/Switch";
import {Validators} from "../form/Validators";


interface Props extends RouteComponentProps {

}

interface State extends LoadingViewState{
    settings?: Settings;
    validationMap? : any;
    menuOrder: MenuItem[];
    editMenuIndex? : number;
    themes: string[]
}

export class SettingsGeneralView extends RouterView<Props,State> implements FormListener<Settings>{

    settingsService: SettingsService;
    defaultMenuOrder: MenuItem[];
    draggedItem:any;
    draggedIdx:any;
    themes:string[];

    constructor(props:Props) {
        super(props);
        this.settingsService = getContainer().getSettingsService();
        this.defaultMenuOrder = [{ type : MenuItemType.POKER},{ type : MenuItemType.CASINO}, { type : MenuItemType.SPORTSBOOK}, { type : MenuItemType.RACING}]
        this.draggedItem = "";
        this.draggedIdx = null;
        this.themes=[];
        this.state = {validationMap : {}, loading : true, menuOrder: [] , editMenuIndex : -1, themes: []};
    }

    loadContent(): Promise<any> | undefined {
        return this.settingsService.getSettings().then((data : Settings) => {
            console.log(data);
            let menu : Menu | undefined = data.menu;
            try {
                console.log(data);
                data.cssOverrideUrlDark=data.cssOverrideUrl!.dark;
                data.cssOverrideUrlLight=data.cssOverrideUrl!.light;
                data.cssOverrideUrl=data.cssOverrideUrl!;
            } catch (error) {
                data.cssOverrideUrlDark=data.cssOverrideUrl!;
                data.cssOverrideUrlLight=data.cssOverrideUrl!;
                data.cssOverrideUrl={"dark": data.cssOverrideUrlDark, "light": data.cssOverrideUrlLight};
            } 
            
            if(menu &&  menu.items) {
                this.setState({ settings:data, menuOrder : menu.items });
            } else {
                this.setState( { settings:data, menuOrder : this.defaultMenuOrder});
            }

        });
    }



    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        super.componentDidUpdate(prevProps, prevState);

    }
    formDidUpdate(formModel:Settings, validationMap : any) {
        this.setState({ settings : formModel, validationMap : validationMap});
    }

    onSubmit():Promise<any> {
        if(!this.state.settings) {
            return Promise.reject("Unable to save settings");
        }
        let settings = this.state.settings;
        if(settings.menu) {
            settings.menu.items = this.state.menuOrder;
        } else {
            settings.menu = {};
            settings.menu.items = this.state.menuOrder;
        }
        let valueJSON: any = {
            "dark": settings.cssOverrideUrlDark ? settings.cssOverrideUrlDark: "",
            "light": settings.cssOverrideUrlLight ? settings.cssOverrideUrlLight: ""
        };
        settings.cssOverrideUrl=valueJSON;
        this.setState({ settings : Object.assign({}, this.state.settings , { cssOverrideUrl : valueJSON})});
        return this.settingsService.saveSettings(settings).catch(err=>{
            // eslint-disable-next-line no-throw-literal
            throw "Unable to create/save settings";
        });
    }

    onDragStart = (e:any, index:any) => {
        console.log("ondragstart e: ", e)
        console.log("ondragstart index: ", index)
        this.draggedItem = this.state.menuOrder[index];
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/html", e.target.parentNode);
        e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);
    };

    onDragOver = (index:any )=> {
        const draggedOverItem = this.state.menuOrder[index];

        // if the item is dragged over itself, ignore
        if (this.draggedItem === draggedOverItem) {
            return;
        }

        // filter out the currently dragged item
        let items = this.state.menuOrder.filter(menuItem => menuItem !== this.draggedItem);

        // add the dragged item after the dragged over item
        items.splice(index, 0, this.draggedItem);
        console.log("Menu order in state: ", this.state.menuOrder);
        console.log("Menu order in dragover func: ", items);
        console.log("Menu order in settings: ", this.state.settings && this.state.settings.menu)

        this.setState({ menuOrder:items });
    };

    onDragEnd = () => {
        this.draggedIdx = null;
    };
    edit(index : number) {
        this.setState({ editMenuIndex : index });
    }
    save(item : MenuItem) {
        if(typeof(this.state.editMenuIndex) != "undefined") {
            let menuOrder =  this.state.menuOrder.concat();
            menuOrder[this.state.editMenuIndex] = item;
            let settings = Object.assign({}, this.state.settings, { menu : { items : menuOrder }});
            this.setState({ editMenuIndex : -1, menuOrder : menuOrder, settings : settings});
        }

    }
    remove(){
        let menuOrder = this.state.menuOrder.concat();
        if(typeof(this.state.editMenuIndex) != "undefined") {
            menuOrder.splice(this.state.editMenuIndex, 1);
        }
        let settings = Object.assign({}, this.state.settings, { menu : { items : menuOrder }});
        console.log("settings = ", settings);
        this.setState({ settings : settings, editMenuIndex : -1, menuOrder : menuOrder});
    }
    add() {
        this.setState({ editMenuIndex : this.state.menuOrder.length});
    }
    cancel() {
        this.setState({editMenuIndex : -1});
    }
    getDragNDropMenuOrderSetting() {
        let renderList = (
            <div className="drag-n-drop-container">
                <main>
                    <ul>
                        {this.state.menuOrder.map((item, idx) => (
                            <li key={item.type !== MenuItemType.CUSTOM ? (item.name+idx.toString()) : (item.type+idx.toString())} onDragOver={() => this.onDragOver(idx)}>
                                <div
                                    className="drag"
                                    draggable
                                    onDragStart={e => this.onDragStart(e, idx)}
                                    onDragEnd={this.onDragEnd}
                                >
                                    <i className="fe-menu"/>
                                </div>
                                <span className="content">{item.type !== MenuItemType.CUSTOM ? item.type : item.name} <a href="/#" onClick={(e:any)=> { e.preventDefault(); this.edit(idx);}}> <i className={"fe-edit"}></i></a></span>
                            </li>
                        ))}
                    </ul>
                </main>
                <a href="/#" onClick={(e:any)=>{ e.preventDefault(); this.add();}} style={{paddingTop : "16px", marginLeft : "2px"}}className={"btn btn-primary"}>NEW <i className={"fe-plus-circle"}></i></a>
                {typeof this.state.editMenuIndex != "undefined" && this.state.editMenuIndex >= 0 && (
                    <EditMenuItem item={this.state.menuOrder[this.state.editMenuIndex] ? this.state.menuOrder[this.state.editMenuIndex] : {}} cancel={()=>this.cancel()} onDelete={()=>this.remove()} onSave={(item : MenuItem)=> this.save(item)}/>
                )}
            </div>
        );

        return renderList;
    }

    onSubmitError(){}

    getTitle() : string {
        return "General Settings";
    }

    renderContent() {
        if(!this.state.settings) {
            return <span></span>
        }
        return(
            <Fragment>
                <Form className="form-horizontal" formListener={this} modelObject={this.state.settings} validationMap={this.state.validationMap}>
                    <div className={"card"}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Settings was updated successfully"/>

                                    <FormGroup className="form-group mb-3" model="operatorName">
                                        <label>Brand Name</label>
                                        <FormInput className="form-control" model="operatorName" type="text"/>
                                        <span className={"help-block"}>The brand name of the site, e.g. 'Nano Casino'</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="operatorIconUrl">
                                        <label>Brand Icon Logo</label>
                                        <FormInput className="form-control" model="operatorIconUrl" type="text"/>
                                        <span className={"help-block"}>Icon with your logo. Recommended size: 96 x 96px. Full URL, HTTPS required.</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="title">
                                        <label>Title</label>
                                        <FormInput className="form-control" model="title" type="text"/>
                                        <span className={"help-block"}>Set title of casino frontend</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="cssOverrideUrl">
                                        <label>CSS Override Url</label>
                                        <FormInput className="form-control" model="cssOverrideUrl" type="hidden"/>
                                    </FormGroup>
                                    <FormGroup className="form-group mb-3" model="cssOverrideUrl">
                                        <label>Dark Theme</label>
                                        <FormInput className="form-control" model="cssOverrideUrlDark" type="text"/>
                                    </FormGroup>
                                    <FormGroup className="form-group mb-3" model="cssOverrideUrl">
                                        <label>Light Theme</label>
                                        <FormInput className="form-control" model="cssOverrideUrlLight" type="text"/>
                                    </FormGroup>
                                    <FormGroup className="form-group mb-3" model="contenfulSpaceId">
                                        <label>Contenful Space Id</label>
                                        <FormInput className="form-control" model="contenfulSpaceId" type="text"/>
                                        <span className={"help-block"}>Contenful Space Id - This can be found at <a href={"https://app.contentful.com"} rel="noreferrer" target="_blank">https://app.contentful.com</a></span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="contentfulAccessToken">
                                        <label>Contentful Access Token</label>
                                        <FormInput className="form-control" model="contentfulAccessToken" type="text"/>
                                        <span className={"help-block"}>Contentful Access Token - This can be found at <a href={"https://app.contentful.com"} rel="noreferrer" target="_blank">https://app.contentful.com</a></span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="acquisitionScript">
                                        <label>Acquisition Script</label>
                                        <FormInput className="form-control" model="acquisitionScript" type="textarea"/>
                                        <span className={"help-block"}>Add script urls that loads when the user has succesfully registered a new user account. ex. https://testscript.nano.com NOTE: One script per row</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="customScripts">
                                        <label>Custom Scripts/CSS/Fonts</label>
                                        <FormInput style={{height: "200px"}}className="form-control" model="customScripts" type="textarea"/>
                                        <span className={"help-block"}>Add script/css urls that loads one time when the page is loaded. ex.<br/>
                                        script:https://testscript.nano.com<br/>
                                        font:https://fonts.googleapis.com/css?family=Rubik<br/>
                                        css:https://cubeia.com/custom-css.css
                                        </span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <label>Products </label>
                                    <span className={"help-block"}> - Toggle products on and off</span>
                                    <FormGroup className="custom-control custom-checkbox" model="casinoEnabled">
                                        <FormInput className="custom-control-input"  id={"casinoEnabled"} model="casinoEnabled" type="checkbox"/>
                                        <label htmlFor={"casinoEnabled"} className={"custom-control-label"}>Casino</label>
                                        <span className=""></span>
                                    </FormGroup>

                                    <FormGroup className="custom-control custom-checkbox" model="pokerEnabled">
                                        <FormInput className="custom-control-input" model="pokerEnabled" id={"pokerEnabled"} type="checkbox"/>
                                        <label htmlFor={"pokerEnabled"} className={"custom-control-label"}>Poker</label>
                                    </FormGroup>

                                    <FormGroup className="custom-control custom-checkbox" model="sportsbookEnabled">
                                        <FormInput className="custom-control-input" model="sportsbookEnabled" id={"sportsbookEnabled"} type="checkbox"/>
                                        <label htmlFor={"sportsbookEnabled"} className={"custom-control-label"}>Sportsbook</label>
                                    </FormGroup>
                                    
                                    <FormGroup className="custom-control custom-checkbox" model="racingEnabled">
                                        <FormInput className="custom-control-input" model="racingEnabled" id={"racingEnabled"} type="checkbox"/>
                                        <label htmlFor={"racingEnabled"} className={"custom-control-label"}>Racing</label>
                                    </FormGroup>

                                    <FormGroup className="custom-control custom-checkbox" model="bonusEnabled">
                                        <FormInput className="custom-control-input" model="bonusEnabled" id={"bonusEnabled"} type="checkbox"/>
                                        <label htmlFor={"bonusEnabled"} className={"custom-control-label"}>Bonuses</label>
                                    </FormGroup>

                                    <FormGroup className="custom-control custom-checkbox" model="ticketsEnabled">
                                        <FormInput className="custom-control-input" model="ticketsEnabled" id={"ticketsEnabled"} type="checkbox"/>
                                        <label htmlFor={"ticketsEnabled"} className={"custom-control-label"}>Tickets</label>
                                    </FormGroup>

                                    <FormGroup className="custom-control custom-checkbox" model="contestEnabled">
                                        <FormInput className="custom-control-input" model="contestEnabled" id={"contestEnabled"} type="checkbox"/>
                                        <label htmlFor={"contestEnabled"} className={"custom-control-label"}>Contest</label>
                                    </FormGroup>

                                    <FormGroup className="custom-control custom-checkbox" model="paymentEnabled">
                                        <FormInput className="custom-control-input" model="paymentEnabled" id={"paymentEnabled"} type="checkbox"/>
                                        <label htmlFor={"paymentEnabled"} className={"custom-control-label"}>Payment</label>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>

                                    <label>Menu Order</label>
                                    {this.getDragNDropMenuOrderSetting()}

                                    <span className={"help-block"}>Drag and drop the items in the order you want the menu items to appear on the site</span>

                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group mb-3" model="sportsbookProvider">
                                        <label>Sportsbook Provider</label>
                                        <SelectInput className="form-control" model="sportsbookProvider" type="text" values={["SONG88","ULTRAPLAY"]}/>
                                        <span className={"help-block"}>Make sure you have valid integration credentials from the provider if you change this</span>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group mb-3" model="loginRedirectUrl">
                                        <label>Login Redirect</label>
                                        <FormInput className="form-control" model="loginRedirectUrl" type="text"/>
                                        <span className={"help-block"}>Path to redirect after successful login. ex. /poker, /poker/play (direct to poker client), /casino, /sportsbook etc.</span>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group mb-3" model="logoutRedirectUrl">
                                        <label>Logout Redirect Url</label>
                                        <FormInput className="form-control" model="logoutRedirectUrl" type="text"  validators={[Validators.url()]}/>
                                        <span className={"help-block"}>When this value is empty the page will perform a reload. When the value is a partial url (i.e /casino) the page will do an internal redirect to an internal page. When the value is a full url the page will do an external redirect</span>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>


                                    <label>Currency</label>
                                    <FormGroup className="form-group mb-3" model="currencyOrder">
                                        <label>Currency Order</label>
                                        <FormInput className="form-control" model="currencyOrder" type="text"/>
                                        <span className={"help-block"}>Use the comma separated list to sort in which order currencies appear ex. EUR,BTC,SEK (note: no spaces)</span>
                                    </FormGroup>
                                    <FormGroup className="form-group mb-3" model="bundleBonusCurrency">
                                        <label>Bundle Bonus Currency</label>
                                        <FormInput className="form-control" model="bundleBonusCurrency" type="text"/>
                                        <span className={"help-block"}>Show "Free Bonus" instead of "Bundle Purchase" for this currency in the player transaction list</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="forceWithdrawCurrency">
                                        <label>Force Withdraw Currency</label>
                                        <FormInput className="form-control" model="forceWithdrawCurrency" type="text"/>
                                        <span className={"help-block"}>If set then withdraw will always use this Currency and not the one currently selected. Used when you have a play money and real money currency.</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <label>User Interaction </label>
                                    <FormGroup className="custom-control custom-checkbox" model="useStoreInsteadOfDeposit">
                                        <FormInput className="custom-control-input" model="useStoreInsteadOfDeposit" id={"useStoreInsteadOfDeposit"} type="checkbox"/>
                                        <label htmlFor={"useStoreInsteadOfDeposit"} className={"custom-control-label"}>Use store instead of deposit</label><br/>
                                        <span className={"help-block"}>Show the bundles purchases instead of regular deposit dialog. Disables deposits.</span>
                                    </FormGroup>
                                    <FormGroup className="custom-control custom-checkbox" model="showCurrencySelectOnSignup">
                                        <FormInput className="custom-control-input" model="showCurrencySelectOnSignup" id={"showCurrencySelectOnSignup"} type="checkbox"/>
                                        <label htmlFor={"showCurrencySelectOnSignup"} className={"custom-control-label"}>Show currency select on signup</label><br/>
                                        <span className={"help-block"}>Shows or hides the drop down where a user selects currency for deposit in the signup flow</span>
                                    </FormGroup>
                                    <FormGroup className="custom-control custom-checkbox" model="useInfoTextSignup">
                                        <FormInput className="custom-control-input" model="useInfoTextSignup" id={"useInfoTextSignup"} type="checkbox"/>
                                        <label htmlFor={"useInfoTextSignup"} className={"custom-control-label"}>Use specific info text terms on registration</label><br/>
                                        <span className={"help-block"}>Specific terms that needs to be accepted before registering a new account</span>
                                    </FormGroup>
                                    <FormGroup className="custom-control custom-checkbox" model="skipDepositPageOnRegister">
                                        <FormInput className="custom-control-input" model="skipDepositPageOnRegister" id={"skipDepositPageOnRegister"} type="checkbox"/>
                                        <label htmlFor={"skipDepositPageOnRegister"} className={"custom-control-label"}>Skip deposit page on signup</label><br/>
                                        <span className={"help-block"}>Skip the deposit page in the signup flow</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox float-e-margins">
                                        <div className="ibox-content">
                                            <div className="ibox-title">
                                                <h5>Actions</h5>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-sm-10 col-sm-offset-2">
                                                    <Submit className="btn btn-primary waves-effect waves-light">Save Settings</Submit>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>


            </Fragment>
        )
    }

}
interface EditMenuItemState {
    form? : MenuItem;
    validationMap? : any;
}
interface EditMenuItemProps{
    item : MenuItem,
    cancel : ()=> void
    onSave : (item : MenuItem)=>void;
    onDelete : () => void;
}
class EditMenuItem extends React.Component<EditMenuItemProps, EditMenuItemState> implements FieldSetListener<MenuItem> {

    constructor(props : EditMenuItemProps) {
        super(props);
        let form = Object.assign({}, props.item);
        if(!form.translations) {
            form.translations = {};
        }
        this.state = { form : form, validationMap : {}};
    }
    removeTranslation(lang? : string) {
        if(lang && this.state.form && this.state.form.translations) {
            let trans = Object.assign({}, this.state.form.translations);
            delete trans[lang];
            this.setState({ form : Object.assign({}, this.state.form, { translations : trans})})
        }
    }
    addTranslation(lang : string, name : string) {
        if(this.state.form && this.state.form.translations) {
            let trans = Object.assign({}, this.state.form.translations);
            trans[lang] = name;
            this.setState({ form : Object.assign({}, this.state.form, { translations : trans})})
        }
    }
    save() {
        this.state.form && this.props.onSave(this.state.form);
    }
    render() {
        if(!this.state.form){
           return <span/>
        }

        return (
            <Modal show={true}  size="lg" onHide={()=>this.props.cancel()}>
                <Modal.Body>
                    <h4>Edit Menu Item <a className={"btn btn-danger pull-right"}  onClick={()=>this.props.onDelete()}>Remove</a></h4>
                    <div className={"form"}>
                        <SimpleFieldSet formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                            <FormGroup className={"form-group"}>
                                <label>Type</label>
                                <SelectInput className={"form-control"} model={"type"} values={[MenuItemType.POKER, MenuItemType.CASINO, MenuItemType.SPORTSBOOK, MenuItemType.RACING, MenuItemType.CUSTOM, MenuItemType.CONTEST, MenuItemType.PAYMENT]}/>
                                <span className={"help-block"}>Select what type of menu item you want to add, you can either choose a predefined product menu item or CUSTOM to add any type of menu item. </span>
                            </FormGroup>
                            <Switch value={this.state.form.type}>
                                <Case value={MenuItemType.CUSTOM}>
                                    <FormGroup  className={"form-group"}>
                                        <label>Name</label>
                                        <FormInput className={"form-control"} model={"name"} validators={[Validators.required()]}/>
                                        <span className={"help-block"}>The default translation, displayed to the user, of the of the menu item if the specific translation does not exist</span>
                                    </FormGroup>
                                    <FormGroup  className={"form-group"}>
                                        <label>Url</label>
                                        <FormInput className={"form-control"} model={"url"} validators={[Validators.required()]}/>
                                        <span className={"help-block"}>The Menu items URL, if it starts with / it will be considered to be an internal link and language etc will be appended automatically. (eg /poker) <br/>
                                        If it's an external URL you can use <span dangerouslySetInnerHTML={{__html : "{languageCode}"}}></span> in the URL to get the current user language <br/>(eg https://test.com/?lang= <span dangerouslySetInnerHTML={{__html : "{languageCode}"}}></span></span>
                                    </FormGroup>
                                    <FormGroup className={"form-group"}>
                                        <label>Target</label>
                                        <FormInput className={"form-control"} model={"target"}/>
                                        <span className={"help-block"}>Link target, if you want to open the menu item in a new tab etc</span>
                                    </FormGroup>
                                    <FormMap  meta={{ title : "Translations", key : "Language", value : "Name"}} removeAttribute={(key)=>this.removeTranslation(key)} addAttribute={(key, value)=>this.addTranslation(key,value)} mapModel={"translations"}/>

                                </Case>
                            </Switch>
                            <div style={{marginTop : "10px"}}>
                                <a  className={"btn btn-primary"} onClick={()=>this.props.cancel()}>Cancel</a>
                                <a  className={"btn btn-success"}  onClick={()=> this.save()}>Save</a>
                            </div>
                        </SimpleFieldSet>
                    </div>

                </Modal.Body>
            </Modal>
        );
    }

    formDidUpdate(formModel: MenuItem, validationMap?: any): void {

        this.setState({ form : formModel, validationMap : validationMap});
    }
}

export default withRouter(SettingsGeneralView);